
import Index from "./index.vue";
export default (Application) => {
    let vce = Application.proc.make('VueCustomElement')
    vce.createApp({
        name: "technology-preview",
        category: "工具",
        alias: "工艺预览",
        singleton: true,
        showTitle: false, 
    }, Index)

}